module.exports = __webpack_public_path__ + "img/inge-v9-5.b07c9934.png";